import type { NitroFetchOptions } from 'nitropack';
import type { LocationAddress, Location } from '~/types';
import type { PaginatedPayload, CustomPagination } from 'x1-base/types';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import { omit as lo_omit } from 'es-toolkit';

export function useLocations() {
    const apiBasePath = `/v1/locations`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function getRetailLocations(): Promise<PaginatedPayload<Location> | Error | void> {
        let payload: Location[];
        let paginatedPayload: PaginatedPayload<Location>;
        const url = `${apiBasePath}/`;
        const config: NitroFetchOptions<string> = {
            method: 'GET',
            query: { all: true }
        };

        try {
            const response = await $_fetch<CustomPagination<Location>>(url, config);
            payload = response.results;

            paginatedPayload = {
                pagination: lo_omit(response, ['results']),
                data: payload
            };

            return paginatedPayload;
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    return {
        getRetailLocations
    };
}
